<template>
  <div
    class="pc-homework-page"
    :class="{ 'electron-homework-page': isElectron }"
  >
    <i
      v-if="showBackBtn"
      @click="handleGoBack"
      class="back-btn el-icon-arrow-left"
    ></i>
    <!-- 操作区 -->
    <div v-if="startAnswer" class="operate-wrap">
      <button
        v-preventReClick
        v-if="canSubmit"
        @click="submitAnswer"
        class="submit-paper-btn"
      >
        <img src="../../../assets/images/homework/submit-btn.png" alt="" />交卷
      </button>
    </div>
    <!-- 头部 -->
    <div class="page-header-wrap">
      <div class="cont-wrap">
        <!-- 页面标题 -->
        <div class="page-title-wrap">
          <span v-if="showAnswerReport">答题报告</span>
          <span v-else-if="startAnswer">{{ workInfo.homework_name }}</span>
        </div>
      </div>
    </div>
    <div class="page-cont-wrap" v-if="workInfo?.id">
      <answer-report v-if="showAnswerReport" />
      <div
        v-if="startAnswer || showAnswerReport"
        :style="handleQuestionsListWrapStyle"
      >
        <template v-if="questionInfoList?.length">
          <div
            class="question-item-wrap"
            v-for="questionInfo in questionInfoList"
            :key="questionInfo.id"
          >
            <!-- 复合题 -->
            <compound-question
              v-if="questionInfo.isCompoundQuestion"
              :question-info="questionInfo"
              class="big-course-question"
            />
            <choice-question
              v-else
              class="big-course-question"
              :question-info="questionInfo"
            />
          </div>
          <!-- 答题卡 -->
          <AnswerSheet @toggleAnswerSheet="handleToggleAnswerSheet" />
        </template>
        <el-empty
          style="height: 400px"
          v-else
          description="暂无内容"
          :image="require('@/assets/img/live-list/empty.png')"
        ></el-empty>
      </div>
      <!-- 作业描述 -->
      <homework-desc v-else />
    </div>
  </div>
</template>

<script>
import { jsToFlutter } from "@saas/components/src/utils/js-to-flutter";
import { WORK_STATUS } from "@saas/components/src/constants/question";
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import HomeworkDesc from "@saas/pages/src/homework/components/HomeworkDesc.vue";
import ChoiceQuestion from "@saas/pages/src/homework/components/ChoiceQuestion.vue";
import CompoundQuestion from "@saas/pages/src/homework/components/CompoundQuestion.vue";
import AnswerSheet from "@saas/pages/src/homework/components/AnswerSheet.vue";
import AnswerReport from "@saas/pages/src/homework/components/AnswerReport.vue";
import { isHXApp } from "@saas/components";
import { EventBus } from "@saas/components/src/utils/event-bus";
export default {
  data: function () {
    return {
      isElectron: window.isElectron,
      drawerHeight: 0, //答题卡高度
      isDrawerOpen: false, //答题卡状态
      WORK_STATUS,
      isHXApp: false,
    };
  },
  created() {
    this.isHXApp = isHXApp();
    let id = this.$route.params.id;
    let userId = this.$route.query.userId;
    this.setStartAnswer(false);
    this.$store.commit("defaultHomework/setUserId", userId);
    if (this.isHXApp) {
      jsToFlutter("getToken");
      EventBus.$off("setToken");
      EventBus.$on("setToken", (isLogin) => {
        // 作业详情
        this.apiGetWorkInfo({ id });
      });
    } else {
      this.apiGetWorkInfo({ id });
    }
  },
  components: {
    HomeworkDesc,
    ChoiceQuestion,
    CompoundQuestion,
    AnswerSheet,
    AnswerReport,
  },
  computed: {
    ...mapGetters("defaultHomework", ["canSubmit"]),
    ...mapState("defaultHomework", [
      "workInfo",
      "startAnswer",
      "questionInfoList",
      "isCorrected",
      "showAnswerReport",
    ]),
    // 处理页面底部padding
    handleQuestionsListWrapStyle() {
      return {
        paddingBottom: this.isDrawerOpen
          ? `${this.drawerHeight + 60}px`
          : "150px",
      };
    },
    showBackBtn() {
      if (window.history && window.history.length === 1) {
        return false;
      } else {
        return true;
      }
    },
  },
  methods: {
    ...mapMutations("defaultHomework", [
      "setStartAnswer",
      "setShowAnswerReport",
      "setShowErrorAnalysis",
    ]),
    ...mapActions("defaultHomework", ["apiGetWorkInfo", "submitAnswer"]),
    handleGoBack() {
      if (this.canSubmit && this.startAnswer) {
        this.$confirm(`退出后会为您自动保存`, "提示", {
          cancelButtonText: "退出",
          confirmButtonText: "继续作答",
          customClass: "saas-confirm-message",
          confirmButtonClass: "confirm-btn",
          cancelButtonClass: "cancel-btn",
          closeOnClickModal: false,
          showClose: false,
        })
          .then(() => {})
          .catch(() => {
            this.goBack();
          });
      } else {
        this.goBack();
      }
    },
    goBack() {
      if (this.isHXApp) {
        // app-判断是否有上一级页面，有调用自己的返回，没有调用flutter的返回
        console.log(this.$route.query, "========changeNav");
        if (this.$route.query.fromName) {
          this.$router.back();
        } else {
          jsToFlutter("closePage");
        }
      } else {
        this.$router.back();
      }
    },
    handleToggleAnswerSheet({ drawerHeight, isDrawerOpen }) {
      this.drawerHeight = drawerHeight;
      this.isDrawerOpen = isDrawerOpen;
    },
  },
};
</script>

<style lang="scss" scoped>
$header-height: 70px;
.pc-homework-page {
  background: #f7f8fa;
  min-height: 100vh;
  padding-bottom: 15px;
  .back-btn {
    position: fixed;
    left: 50%;
    top: 27px;
    transform: translateX(-600px);
    font-size: 18px;
    color: #4e5969;
    font-weight: bold;
    // -webkit-app-region: none;
    z-index: 1999;
    -webkit-app-region: no-drag;
    cursor: pointer;
  }
  .operate-wrap {
    position: fixed;
    right: 50%;
    top: 27px;
    transform: translateX(600px);
    font-weight: 400;
    font-size: 16px;
    color: #0d1400;
    line-height: 1;
    z-index: 1999;
    -webkit-app-region: no-drag;
  }
  .submit-paper-btn {
    display: flex;
    align-items: center;
    img {
      width: 20px;
      height: 20px;
      margin-right: 4px;
    }
    -webkit-app-region: none;
  }
  //头部
  .page-header-wrap {
    width: 100%;
    position: fixed;
    top: 0;
    right: 0;
    z-index: 9;
    background: #ffffff;
    backdrop-filter: blur(6px);
    .cont-wrap {
      position: relative;
      display: flex;
      align-items: center;
      // width: 1200px;
      width: 100%;
      height: 70px;
      margin: 0 auto;
    }

    .page-title-wrap {
      max-width: 400px;
      margin: 0 auto;
      text-align: center;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-weight: 500;
      font-size: 16px;
      color: #0d1400;
      line-height: 1;
    }
  }

  .page-cont-wrap {
    width: 1200px;
    margin: 0 auto;
    padding-top: calc(#{$header-height} + 20px);
  }

  .big-course-question {
    padding-top: $header-height;
    margin-top: -$header-height;
    margin-bottom: 20px;
  }
}

// 客户端
.electron-homework-page.pc-homework-page {
  //头部
  .page-header-wrap {
    width: calc(100% - #{$side-bar-width});
  }
  .back-btn {
    position: fixed;
    left: calc(50% + #{$side-bar-width} / 2);
    top: 27px;
    transform: translateX(-600px);
  }
  .operate-wrap {
    position: fixed;
    right: calc(50% - #{$side-bar-width} / 2);
    top: 27px;
    transform: translateX(590px);
  }
  .page-header-wrap {
    .cont-wrap {
      height: 60px;
    }
    .page-title-wrap {
      padding-top: 10px;
    }
  }
}

// 适配
@media (max-width: 1200px) {
  .pc-homework-page {
    .back-btn {
      left: 20px;
      transform: none;
    }
    .operate-wrap {
      right: 20px;
      transform: none;
    }
    .page-cont-wrap {
      width: 100%;
      padding-left: 0;
      padding-right: 0;
      min-width: 520px;
    }
  }
}
</style>
<style lang="scss" scoped>
// 客户端
.win-app .electron-homework-page {
  .page-header-wrap {
    padding-top: 13px;
  }
  .back-btn,
  .operate-wrap {
    top: 40px;
  }
}
</style>
